import { useLingui } from '../../../../../../node_modules/@lingui/react/dist/index.mjs';
import React__default, { useMemo } from 'react';
import { useGlobalReducer } from '../../b2b/GlobalContextProvider.mjs';
import { AppScreens } from '../../b2b/types/AppScreens.mjs';
import { ErrorType } from '../../b2b/types/ErrorType.mjs';
import Button from '../atoms/Button.mjs';
import Column from '../atoms/Column.mjs';
import TextColumn from './TextColumn.mjs';

const ErrorDisplay = ({ text, onGoBack })=>{
    const { i18n: $__i18n, _: $__ } = useLingui();
    return /*#__PURE__*/ React__default.createElement(Column, {
        gap: 6
    }, /*#__PURE__*/ React__default.createElement(TextColumn, {
        header: $__i18n._({
            id: "error.title"
        }),
        body: text
    }), onGoBack && /*#__PURE__*/ React__default.createElement(Button, {
        variant: "outline",
        onClick: onGoBack
    }, $__i18n._({
        id: "button.goBack"
    })));
};
const ErrorScreen = ()=>{
    const [state, dispatch] = useGlobalReducer();
    const { i18n: $__i18n, _: $__ } = useLingui();
    const { type: currentErrorType, canGoBack } = state.error;
    const organizationName = state.flowState.organization?.organization_name;
    const ErrorTypeMap = {
        [ErrorType.Default]: $__i18n._({
            id: "error.default"
        }),
        [ErrorType.EmailMagicLink]: $__i18n._({
            id: "error.eml"
        }),
        [ErrorType.Organization]: $__i18n._({
            id: "error.organization"
        }),
        [ErrorType.CannotJoinOrgDueToAuthPolicy]: organizationName ? $__i18n._({
            id: "error.authPolicyWithOrg",
            values: {
                organizationName: organizationName
            }
        }) : $__i18n._({
            id: "error.authPolicyNoOrg"
        }),
        [ErrorType.AdBlockerDetected]: $__i18n._({
            id: "error.adBlockerDetected"
        }),
        [ErrorType.OrganizationDiscoveryClaimedDomain]: $__i18n._({
            id: "error.claimedDomain"
        })
    };
    const handleGoBack = useMemo(()=>{
        if (canGoBack) {
            return ()=>dispatch({
                    type: 'transition',
                    screen: AppScreens.Main
                });
        }
        return undefined;
    }, [
        canGoBack,
        dispatch
    ]);
    return /*#__PURE__*/ React__default.createElement(ErrorDisplay, {
        text: ErrorTypeMap[currentErrorType],
        onGoBack: handleGoBack
    });
};

export { ErrorDisplay, ErrorScreen };
//# sourceMappingURL=ErrorScreen.mjs.map
